import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "p6rqhgmu7__mask0_222_15446",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20",
        children: _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#p6rqhgmu7__mask0_222_15446)",
        children: [_jsx("path", {
          d: "M24 1H-3V19H24V1Z",
          fill: "#D7141A"
        }), _jsx("path", {
          d: "M24 1H-3V10H24V1Z",
          fill: "white"
        }), _jsx("path", {
          d: "M10.5 10L-3 1V19L10.5 10Z",
          fill: "#11457E"
        }), _jsx("path", {
          d: "M10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5Z",
          stroke: "#152361"
        })]
      })]
    }))
  });
};
export default Component;
